import * as React from 'react'
import PropTypes from 'prop-types'
import '@tiptap-ui/components/tiptap-ui-primitive/badge/badge-colors.scss'
import '@tiptap-ui/components/tiptap-ui-primitive/badge/badge-group.scss'
import '@tiptap-ui/components/tiptap-ui-primitive/badge/badge.scss'

export const Badge = React.forwardRef((
  {
    variant,
    size = 'default',
    appearance = 'default',
    trimText = false,
    className,
    children,
    ...props
  },
  ref
) => {
  return (
    <div
      ref={ref}
      className={`tiptap-badge ${className || ''}`}
      data-style={variant}
      data-size={size}
      data-appearance={appearance}
      data-text-trim={trimText ? 'on' : 'off'}
      {...props}
    >
      {children}
    </div>
  )
})

Badge.displayName = 'Badge'

Badge.propTypes = {
  variant: PropTypes.string,
  size: PropTypes.string,
  appearance: PropTypes.string,
  trimText: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
}

export default Badge
